import React from "react";
import { useTranslation } from "react-i18next";
import { MailWarning } from "lucide-react";
import { fmtDateTime } from "../../lib/format";

/**
 * Phase 2B.2 — delivery-problem warning for the latest email attempt.
 *
 * Rendered only when the backend returns `email_alert` on the quotation detail
 * response (latest attempt is bounced / failed / complained). Purely
 * informational: it never resends and never changes the quotation status.
 */
export default function DeliveryAlert({ alert, onFocusEmails }) {
  const { t } = useTranslation();
  if (!alert) return null;

  return (
    <div
      className={`qw-delivery-alert tone-${alert.tone || "danger"}`}
      role="alert"
      data-testid="delivery-alert"
    >
      <span className="qw-delivery-alert-icon" aria-hidden="true">
        <MailWarning size={18} strokeWidth={2} />
      </span>
      <div className="qw-delivery-alert-body">
        <div className="qw-delivery-alert-title" data-testid={`delivery-alert-${alert.status}`}>
          {alert.title}
        </div>
        <div className="qw-delivery-alert-text">
          {alert.message} {alert.guidance}
        </div>
        <div className="qw-delivery-alert-meta">
          {fmtDateTime(alert.occurred_at)}
          {alert.test_mode && (
            <span className="qw-tl-badge test" style={{ marginLeft: 8 }}>
              {t("quotations.email_test_mode_badge")}
            </span>
          )}
        </div>
      </div>
      {onFocusEmails && (
        <button
          type="button"
          className="qw-btn sm"
          onClick={onFocusEmails}
          data-testid="delivery-alert-goto-emails"
        >
          {t("quotations.email_alert_action")}
        </button>
      )}
    </div>
  );
}
